const items = [
  "Free styling guide with every order",
  "100% Human Hair · hand-finished",
  "Worldwide shipping",
  "Inner-circle pricing",
  "Pre-styled · ready to wear",
];

const Marquee = () => {
  // duplicate list so translate loop is seamless
  const loop = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] border-y border-[hsl(var(--primary))]"
    >
      <div className="flex animate-marquee whitespace-nowrap py-3">
        {loop.map((t, i) => (
          <span
            key={i}
            className="mx-8 text-xs uppercase tracking-[0.3em] flex items-center gap-8"
          >
            {t}
            <span className="text-[#B8935F]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
